import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { updatesSelector, devicesUpdatesSelector } from '../selectors/dashboardSelector';
import { getUpdatesRequest, getDevicesUpdatesRequest } from '../actions/dashboardActions';
import UpdatesStatus from '../components/UpdatesStatus/UpdatesStatus';

const mapStateToProps = createStructuredSelector({
    updates: updatesSelector,
    devicesUpdates: devicesUpdatesSelector
});

const mapDispatchToProps = {
    getUpdatesRequest,
    getDevicesUpdatesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatesStatus);
